export enum ScheduledUpdatesColumns {
  ID = "id",
  UpdateType = "updateType",
  Created = "created",
  Modified = "modified",
  DeviceFirmwareID = "deviceFirmwareID", // OR DOES THIS WORKS AS A REPLACEMENT?
  AllowedFrom = "allowedFrom",
  AllowedTo = "allowedTo",
  AllowedFromStr = "allowedFromStr",
  AllowedToStr = "allowedToStr",
  OnlyIgnitionOn = "onlyIgnitionOn",
  OnlyIgnitionOff = "onlyIgnitionOff",
  ImeisStr = "imeisStr",
  Imeis = "imeis",
  CreatedByUserID = "createdByUserID",
  CreatedBy = "createdBy",
  CreatedByUserAvatar = "createdByUserAvatar",
  Status = "status",
  ExecuteJobID = "executeJobID",
  ExpireJobID = "expireJobID",
  History = "history",
  HistoryStr = "historyStr",
  AllowedActions = "allowedActions",
}